import { render, staticRenderFns } from "./log4.vue?vue&type=template&id=2b297fd1&scoped=true"
import script from "./log4.vue?vue&type=script&lang=js"
export * from "./log4.vue?vue&type=script&lang=js"
import style0 from "./log4.vue?vue&type=style&index=0&id=2b297fd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b297fd1",
  null
  
)

export default component.exports